import {
  VERIFY_MAPPING_FIELDS_DATA_REQUEST,
  VERIFY_MAPPING_FIELDS_DATA_SUCCESS,
  VERIFY_MAPPING_FIELDS_DATA_FAIL,
} from '../constants/verifymappingConstants';

export const verifyMappingReducer = (state = { formData: [] }, action) => {
  switch (action.type) {
    case VERIFY_MAPPING_FIELDS_DATA_REQUEST:
      return { loading: true, formData: [] };
    case VERIFY_MAPPING_FIELDS_DATA_SUCCESS:
      return { loading: false, formData: action.payload };
    case VERIFY_MAPPING_FIELDS_DATA_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
